import React from 'react';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { ExperienceBuilder } from './components/ExperienceBuilder';
import { SoundDemo } from './components/SoundDemo';
import { BrandLayer } from './components/BrandLayer';
import { HomeExplorer } from './components/HomeExplorer';
import { AIConsultant } from './components/AIConsultant';
import { BudgetEngine } from './components/BudgetEngine';
import { Difference } from './components/Difference';
import { BeforeAfter } from './components/BeforeAfter';
import { ControlDemo } from './components/ControlDemo';
import { SystemsShowcase } from './components/SystemsShowcase';
import { HomeOS } from './components/HomeOS';
import { SystemPhilosophy } from './components/SystemPhilosophy';
import { CinematicStory } from './components/CinematicStory';
import { ConsultationCTA } from './components/ConsultationCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-void text-platinum font-sans" data-id="element-0">
      <Navigation data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <ExperienceBuilder data-id="element-4" />
        <SoundDemo data-id="element-5" />
        <BrandLayer data-id="element-6" />
        <HomeExplorer data-id="element-7" />
        <AIConsultant data-id="element-8" />
        <BudgetEngine data-id="element-9" />
        <Difference data-id="element-10" />
        <BeforeAfter data-id="element-11" />
        <ControlDemo data-id="element-12" />
        <SystemsShowcase data-id="element-13" />
        <HomeOS data-id="element-14" />
        <SystemPhilosophy data-id="element-15" />
        <CinematicStory data-id="element-16" />
        <ConsultationCTA data-id="element-17" />
      </main>

      <Footer data-id="element-18" />
    </div>;
}